<div class="modal" id="add-user-modal" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="dcf-wrapper dcf-pt-8 dcf-pb-5">
    <h4>{{ data.saveLabel }} user</h4>
    <form id="add-user-form">
      <fieldset>
        <section class="form-group required-input">
          <label class="dcf-label" for="firstName">First Name:</label>
          <input type="text" name="first" [(ngModel)]="data.user.firstName" class="dcf-input-text form-control" id="firstName" required>
        </section>
        <section class="form-group required-input">
          <label class="dcf-label" for="lastName">Last Name:</label>
          <input type="text" name="last" [(ngModel)]="data.user.lastName" class="dcf-input-text form-control" id="lastName" required>
        </section>
        <section class="form-group required-input">
          <label class="dcf-label" for="email">Email Address:</label>
          <input type="text" name="email" [(ngModel)]="data.user.email" class="dcf-input-text form-control" id="email" placeholder="student@huskers.unl.edu" required>
        </section>
        <section class="form-group">
          <label class="dcf-label" for="phone">Phone Number:</label>
          <input type="text" name="phone" [(ngModel)]="data.user.phoneNumber" class="dcf-input-text form-control" id="phone">
        </section>
      </fieldset>
      <div class="dcf-pt-5">
        <button type="submit" class="dcf-btn dcf-btn-primary" (click)="save()">{{ data.saveLabel }} User</button>
        <button type="button" class="dcf-btn dcf-btn-secondary close-modal-button" (click)="close()">Close</button>
      </div>
    </form>
  </div>
</div>